import React from "react";
import { BonusPobjednici } from '../../Layout/BonusPobjednici.jsx';

export class TurnirPrvaka extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tabs: ['Nagrade', 'Bodovi', 'Rezultati'],
            selectedTab: null,
            tuniri: null,
            showTurnir: null,
            turnirPobjednici: null
        }

        this.gotoTab = this.gotoTab.bind(this);
        this.getBody = this.getBody.bind(this);
        this.showTurnirRezultati = this.showTurnirRezultati.bind(this);
        this.fetchData = this.fetchData.bind(this);
        this.fetchTurnirRezultatiData = this.fetchTurnirRezultatiData.bind(this);
        this.setData = this.setData.bind(this);
        this.setTurnirPobjediniciData = this.setTurnirPobjediniciData.bind(this);
        casino.utils.createPageGoogleTagManagerEvent('Bonusi', 'Turninr Prvaka', 'poker', this.props.user);
    }

    showTurnirRezultati(turnir) {
        this.setState({
            showTurnir: turnir,
            turnirPobjednici: null
        });

        this.fetchTurnirRezultatiData(turnir);
    }

    componentDidMount() {
        this.gotoTab(this.state.tabs[0]);
        this.fetchData();
    }

    fetchData() {
        this.props.showLoadingFn(true);

        const promises = Promise.all([casino.repos.pokerPrvenstvoHrvatskeTurniriRepo.list()]);

        this.dataPromises = casino.utils.makeCancelablePromise(promises);
        this.dataPromises.promise.then(this.setData, function (reason) { });
    }

    fetchTurnirRezultatiData(turnir) {
        this.props.showLoadingFn(true);

        const promises = Promise.all([casino.repos.pokerPrvenstvoHrvatskePobjedniciRepo.list(turnir)]);

        this.dataPromises = casino.utils.makeCancelablePromise(promises);
        this.dataPromises.promise.then(this.setTurnirPobjediniciData, function (reason) { });
    }

    componentWillUnmount() {
        if (this.dataPromises)
            this.dataPromises.cancel();
    }

    setData(data) {
        const [turniri] = data;

        this.setState({
            turniri: turniri
        });

        this.props.showLoadingFn(false);
    }

    setTurnirPobjediniciData(data) {
        const [pobjedinici] = data;

        this.setState({
            turnirPobjednici: pobjedinici
        });

        this.props.showLoadingFn(false);
    }

    gotoTab(tab) {
        this.setState({ selectedTab: tab });
    }

    getBody() {

        if (this.state.selectedTab == 'Nagrade') {
            return (<div>

                <h3 className="poker-sub-title">Promocija se sastoji od tri dijela:</h3>
                <div className="padding-sides-medium-2">
                    <h2 className="v3">🏆 1. Turnir Prvaka</h2>
                    <div>
                        <p>Srijedom u 19:00 igramo novi turnir – <b>Mrcina 5.000 € GTD!</b> Pobjednici svake "Mrcine" osvajaju ulaznicu za <b>Turnir Prvaka</b> – VIP turnir koji se igra 04.01.2026. godine i dostupan je samo osvajačima kvalifikacijskih turnira.</p>
                        <p><b>🎁 Glavna nagrada:</b><br></br> Osim novčanog dijela, pobjednik Turnira Prvaka osvaja i <b>33 ulaznice</b> ukupne vrijednosti <b>1.155 €:</b></p>
                        <ul className="list">
                            <li>3 x 165 €</li>
                            <li>5 x 55 €</li>
                            <li>10 x 22 €</li>
                            <li>15 x 11 €</li>
                        </ul>
                    </div>
                </div>
                <br></br>
                <div className="padding-sides-medium-2">
                    <h2 className="v3">👑 2. Dupla Kruna</h2>
                    <div>
                        <p>Osvoji <b>Nedjeljni Classic</b> i <b>Mrcinu</b> u istom mjesecu i preuzmi dodatnu nagradu:</p>
                        <p><b>🎁 Bonus nagrada:</b><br></br>3 ulaznice ukupne vrijednosti <b>275 €</b></p>
                        <ul className="list">
                            <li>1 x 165 €</li>
                            <li>2 x 55 €</li>
                        </ul>
                    </div>
                </div>
                <br></br>
                <div className="padding-sides-medium-2">
                    <h2 className="v3">🔥 3. Kraljevi Grinda – leaderboard</h2>
                    <div>
                        <p>Sudjeluj svakog dana (osim srijedom) u glavnom turniru u 19:00 s oznakom <b>"Kraljevi Grinda"</b> i skupljaj bodove.</p>
                        <p><b>📈 Top 10 igrača</b> s najviše bodova osvaja ulaznice za Turnir Prvaka, a top 5 dijeli i dodatne nagrade:</p>
                        <table className="table-1 v2">
                            <thead>
                                <tr>
                                    <th className="text-left text text-6">Plasman</th>
                                    <th className="text-left text text-6">Nagrada</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr className="horizontal-lines">
                                    <td className="text text-1 nowrap">🥇 1. mjesto</td>
                                    <td className="text text-1">
                                        <b>800 €</b>
                                    </td>
                                </tr>
                                <tr className="horizontal-lines">
                                    <td className="text text-1 nowrap">🥈 2. mjesto</td>
                                    <td className="text text-1">
                                        <b>500 €</b>
                                    </td>
                                </tr>
                                <tr className="horizontal-lines">
                                    <td className="text text-1 nowrap">🥉 3. mjesto</td>
                                    <td className="text text-1">
                                        <b>300 €</b>
                                    </td>
                                </tr>
                                <tr className="horizontal-lines">
                                    <td className="text text-1 nowrap">🏅 4. mjesto</td>
                                    <td className="text text-1">
                                        <b>200 €</b>
                                    </td>
                                </tr>
                                <tr className="horizontal-lines">
                                    <td className="text text-1 nowrap">🏅 5. mjesto</td>
                                    <td className="text text-1">
                                        <b>200 €</b>
                                    </td>
                                </tr>
                            </tbody>
                        </table>


                    </div>
                </div>
            </div>)
        }

        if (this.state.selectedTab == 'Bodovi') {
            return <div className="padding-sides-medium-2">
                <h2 className="v3">{this.state.selectedTab}</h2>
                <div>

                    Bodovi se dodjeljuju po slijedećoj formuli:
                    <br /><br />
                    <div className="max-width-40">
                        <img src="content/images/poker/bonusi/formula_2025.png" />
                    </div>
                    <ul>
                        <li className="text text-2">b = Broj natjecatelja u turniru + broj re-rentrya</li>
                        <li className="text text-2">u = Trošak ulaznice (buy-in) za turnir</li>
                        <li className="text text-2">p = Pojedinačni plasman igrača na turniru</li>
                    </ul>
                    <br />
                    U slučaju izjednačenog broja bodova gledat će se ukupno osvojena svota novaca na svim turnirima koji sudjeluju u promociji.
                </div>
            </div>
        }

        if (this.state.selectedTab == 'Rezultati') {
            return (
                <React.Fragment>
                    <h2 className="v3 padding-sides-medium-2">{this.state.selectedTab}</h2>
                    <BonusPobjednici {...this.props} />
                </React.Fragment>
            )
        }
    }

    renderTabs(tab) {
        return (
            <button
                key={tab}
                onClick={() => this.gotoTab(tab)}
                className={'segment--btn' + (this.state.selectedTab === tab ? ' selected' : '')}>
                <span>{tab}</span>
            </button>
        )
    }

    render() {
        return (
            <div>
                <div className="segment v2 margin-top-small padding-sides-medium-2">
                    {this.state.tabs?.map((tab) => this.renderTabs(tab))}
                </div>
                {this.getBody()}
            </div>
        )
    }
}